import React from "react";
import theme from "../../Styles/theme.scss";
// Components
import PrimaryButton from "../PrimaryButton";
import { DeleteIcon } from "../../Styles/Icons/DesignSystem";

const DeleteButton = ({ label, onClick, padding, disabled }) => (
  <PrimaryButton
    startIcon={<DeleteIcon colour={theme.neutral7} />}
    onClick={onClick}
    backgroundColour={theme.risk3}
    hoverColour={theme.risk4}
    padding={padding ? padding : `4px 16px`}
    disabled={disabled}
    style={{ borderRadius: "8px" }}
  >
    {label}
  </PrimaryButton>
);

export default DeleteButton;
